import { get } from "lodash";
import STATUS_ID_CONSTANTS from "@/constants/status-id-constants";
import Vue from "vue"; // Import Vue

const setVendorInvoices = (state, payload) => {
  const data = get(payload, "content", []);
  state.vendorInvoices.paginationDetails.currentPage = get(payload, "number", 0);
  state.vendorInvoices.paginationDetails.totalPages = get(payload, "totalPages", 0);
  state.vendorInvoices.paginationDetails.pageSize = get(payload, "size", 0);
  state.vendorInvoices.paginationDetails.totalData = get(payload, "totalElements", 0);
  state.vendorInvoices.data = data;
};

const setOrderInvoiceDropdown = (state, payload) => {
  Vue.set(state.vendorInvoices.data[payload.index], "showDropdown", !payload.showDropdown);
};

const setOrderServiceStatus = (state, payload) => {
  state.vendorInvoices.data[payload.index].orderServiceStatus = payload.status;
};

const updateOrder = (state, payload) => {
  const { orderId, type } = payload;
  const { INVOICE_STATUSES } = STATUS_ID_CONSTANTS;
  const { FULFILLMENT_STATUSES } = INVOICE_STATUSES;
  if (type === "update_status") {
    const orderIndex = state.vendorInvoices.data.findIndex(item => item.orderNo === orderId);
    if (orderIndex >= 0) {
      const order = state.vendorInvoices.data[orderIndex];
      const currentStatus = order.fulfillment.status;

      const newStatus = payload.status ? payload.status : [FULFILLMENT_STATUSES.PENDING.value].includes(currentStatus) ? FULFILLMENT_STATUSES.PROCESSING.value : currentStatus;
      state.vendorInvoices.data[orderIndex].fulfillment.status = newStatus;
    }
  }
};

export default {
  setVendorInvoices,
  updateOrder,
  setOrderInvoiceDropdown,
  setOrderServiceStatus,
};
